<template>
  <el-dialog
    :title="`Уведомление по перевозке №${bid.id}`"
    :visible="visible"
    width="50%"
    custom-class="send-notification-modal"
    :close-on-click-modal="false"
    @close="beforeClose"
    @open="beforeOpen"
  >
    <loader-wrapper :loading="isLoading">
      <el-row class="send-group">
        <el-select v-model="group_id" placeholder="Рейсы" clearable>
          <el-option
            v-for="item in recipientsItems"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </el-row>
      <el-row>
        <el-input v-model="textarea" :rows="10" type="textarea" />
      </el-row>
    </loader-wrapper>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loading" @click="onSend">
        Отправить
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import shippingMixin from '@/mixins/shippingMixin'

const Messages = RepositoryFactory.get('messages')

export default {
  name: 'SendNotificationModal',
  components: { LoaderWrapper },

  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      recipientsItems: [
        { name: 'Отправить уведомление всем водителям', id: null },
      ],
      textarea: '',
      loading: false,
      isLoading: false,
      contactsGroup: [],
      group_id: null,
      bid_id: null,
    }
  },
  computed: {
    ...mapGetters({ getLibObj: 'libs/getLibObj' }),
    freightsTypeList() {
      return this.getLibObj('freightTypes')
    },
    nearPriceStorage() {
      let arr = []
      let yesterday = new Date(new Date().setDate(new Date().getDate() - 1))

      if (Object.keys(this.bid).includes('load_days')) {
        this.bid?.load_days.map(item =>
          arr.push({
            load_date:
              new Date(item.load_date) > yesterday
                ? new Date(item.load_date)
                : '',
            price: item.price_from_storage_driver,
          }),
        )
      }
      let minObject =
        arr.length > 0
          ? arr.reduce(
              (prev, current) =>
                prev.load_date < current.load_date ? prev : current,
              {},
            )
          : []

      return minObject?.price || 0
    },
    nearPriceField() {
      let arr = []
      let yesterday = new Date(new Date().setDate(new Date().getDate() - 1))

      if (Object.keys(this.bid).includes('load_days')) {
        this.bid?.load_days.map(item =>
          arr.push({
            load_date:
              new Date(item.load_date) > yesterday
                ? new Date(item.load_date)
                : '',
            price: item.price_from_field_driver,
          }),
        )
      }
      let minObject =
        arr.length > 0
          ? arr.reduce(
              (prev, current) =>
                prev.load_date < current.load_date ? prev : current,
              {},
            )
          : []

      return minObject?.price || 0
    },
  },
  watch: {
    bid(newVal) {
      if (newVal && this.visible) {
        this.bid_id = newVal?.id
        this.setTextarea(newVal)
      }
    },
  },
  methods: {
    getContactsGroups() {
      this.isLoading = true
      Messages.getContactsGroup()
        .then(res => {
          if (res.status === 200) {
            this.recipientsItems = [...this.recipientsItems, ...res.data]
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.isLoading = false))
    },
    getWeightText(count) {
      let text = ' тонн'
      const res10 = count % 10
      const res100 = count % 100

      if (res10 === 1 && res100 !== 11) {
        text = ' тонна'
      }
      if ([2, 3, 4].includes(res10) && ![12, 13, 14].includes(res100)) {
        text = ' тонны'
      }

      return count + text
    },
    setTextarea(newVal) {
      const {
        id,
        freight_id,
        load_point,
        unload_point,
        distance,
        is_trawl,
        lifting_capacity,
        load_days,
      } = newVal
      const price =
        load_days && load_days.length
          ? load_days[load_days.length - 1].price_not_subscribed
          : 0
      let text = `${this.freightsTypeList[freight_id]}`

      text += `, ${this.loadLocationFilter(newVal)} (${
        load_point.split(',')[0]
      })`
      text += `, ${this.findStevedore(newVal) || 'не указан'} (${
        unload_point.split(',')[1]
      })`
      text += `, ${distance} км, ${this.nearPriceStorage} руб/кг`

      text += this.nearPriceField ? `, (${this.nearPriceField} руб/кг)` : ''
      text += is_trawl ? ', грузим траллы' : ''
      text += lifting_capacity
        ? `, весы на погрузке ${this.getWeightText(lifting_capacity)}`
        : ''
      text += '. Запись через приложение или 8(938)4444420'
      this.textarea = text
    },
    onSend() {
      const { textarea: text, group_id, bid_id } = this

      if (text && group_id === null && bid_id) {
        this.loading = true
        Messages.pushMsgRequests({ text, bid_id })
          .then(res => {
            if (res.status === 200) {
              this.$message.success('Уведомление водителям отправлено')
              this.beforeClose()
            }
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      }
      if (text && group_id !== null) {
        this.loading = true
        Messages.pushMsgRequests({ text, group_id })
          .then(res => {
            if (res.status === 200) {
              this.$message.success('Уведомление группе отправлено')
              this.beforeClose()
            }
          })
          .catch(err => this.errHandler(err))
          .finally(() => (this.loading = false))
      }
    },
    beforeClose() {
      this.$emit('close')
      this.textarea = ''
      this.contactsGroup = []
      this.group_id = null
      this.recipientsItems = [
        { name: 'Отправить уведомление всем водителям', id: null },
      ]
    },
    beforeOpen() {
      this.getContactsGroups()
    },
  },
}
</script>

<style lang="sass">
.home .send-notification-modal
  .el-dialog__header
    padding: 20px 40px
    color: #000
  .el-dialog__body
    padding: 0 40px 40px
    color: #000
  .send-group
    margin-bottom: 16px
</style>
